import * as React from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UncheckIcon from "assets/svgIcons/UncheckIcon";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import {
  Container,
  Header,
  BodyWrapper,
  Row,
  AccordionWrapper,
  TableWrapper,
} from "pages/FoodAndBeverages/Orders/OrdersStyled";
import { CircleBtn } from "assets/css/globle";
import { useDispatch } from "react-redux";
import {
  FB_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useEffect, useState } from "react";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useSelector } from "react-redux";
import _ from "lodash";
import { API_STATUSES } from "redux/_helpers/statuses";
import moment from "moment";
import accounting from "accounting-js";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { featureKey, isUserAdmin, isUserSupport } from "constant";

export const Orders = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { sideDrawerState } = useHookstate(SIDENAV_GLOBAL_STATE);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    siteSettingsData,
    getFoodOrdersTabDataState,
    getFoodOrdersTabDataStatus,
    getUserRole
  } = useSelector((state) => state?.commonReducers) || [];

  const { fbOrdersSettings, foodOrdersCourseFilter } = useHookstate(FB_GLOBAL_STATES);

  const [foodOrdersCourses, setFoodOrdersCourses] = useState([]);
  const [showFoodItems, setShowFoodItems] = useState([]);
  const [displayFoodOrders, setDisplayFoodOrders] = useState([]);

  useEffect(() => {
    if (Object.keys(siteSettingsData).length > 0) {
      if (!siteSettingsData?.Features?.includes(featureKey.golf) && !(isUserAdmin(getUserRole?.Role) ||
        isUserSupport(getUserRole?.Role))) {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    startGettingFoodOrders();
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (foodOrdersCourses.length !== 0) {
      foodOrdersCourseFilter.set({
        ...foodOrdersCourseFilter.get(),
        courseFilters: foodOrdersCourses,
      });
      localStorage.setItem(
        "fbOrdersCourseFilter",
        JSON.stringify(foodOrdersCourseFilter.get())
      );
    }
  }, [foodOrdersCourses]);

  useEffect(() => {
    processFoodOrders();
  }, [getFoodOrdersTabDataState]);

  useEffect(() => {
    let finalFoodArr = [];
    foodOrdersCourses.forEach((item) => {
      if (item.active) {
        let tempArr = showFoodItems?.filter(
          (fItem) =>
            fItem.Course === item.number &&
            (!fItem?.FulfilledDate || fbOrdersSettings.get().showCompleted)
        );
        finalFoodArr = [...finalFoodArr, ...tempArr];
      }
    });

    setDisplayFoodOrders(finalFoodArr);
  }, [foodOrdersCourses, showFoodItems, fbOrdersSettings.get().showCompleted]);

  const handleChange = (event) => {
    fbOrdersSettings.set({
      ...fbOrdersSettings.get(),
      refreshInterval: event.target.value,
    });
    localStorage.setItem(
      "fbOrdersSettings",
      JSON.stringify(fbOrdersSettings.get())
    );
  };

  function startGettingFoodOrders() {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let tempData = [];

      siteSettingsData?.Courses.forEach(function (course) {
        // if we have saved away an active setting for this course use it.
        let isActiveCourse = true;
        if (foodOrdersCourseFilter.get().courseFilters) {
          isActiveCourse = _.result(
            _.find(foodOrdersCourseFilter.get().courseFilters, {
              number: course?.Number,
            }),
            "active",
            true
          );
        }

        // Set up the initial values for which courses orders will be shown
        let viewCourseActive = {
          number: course?.Number,
          name: course?.Name,
          active: isActiveCourse,
        };
        tempData.push(viewCourseActive);
      });

      setFoodOrdersCourses(tempData);
    }
  }

  function processFoodOrders() {
    if (fbOrdersSettings.get().fillOrdersHere) {
      let tempArray = JSON.parse(JSON.stringify(getFoodOrdersTabDataState));

      if (tempArray && tempArray.length > 0) {
        tempArray.forEach(function (order) {
          order.showDetail = !order.FulfilledDate;
        });
      }

      setShowFoodItems(tempArray);
    }
  }

  function handleCourseToggle(evt, course) {
    let tempArray = JSON.parse(JSON.stringify(foodOrdersCourses));
    const objIndex = tempArray.findIndex((obj) => obj.number == evt.target.id);

    if (objIndex === -1) {
      return;
    }

    const updatedObj = {
      ...tempArray[objIndex],
      active: !course?.active,
    };

    const updatedtempArray = [
      ...tempArray.slice(0, objIndex),
      updatedObj,
      ...tempArray.slice(objIndex + 1),
    ];

    setFoodOrdersCourses(updatedtempArray);
  }

  function showOrder(order) {
    // determine if this order is for an active course
    let isActiveCourse = _.find(foodOrdersCourses, {
      number: order?.Course,
    })?.active;
    return (
      isActiveCourse &&
      (fbOrdersSettings.get().showCompleted || !order?.FulfilledDate)
    );
  }

  function courseAndHole(order) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      if (order?.Course === 0 || order?.Hole === 0) return "-";
      else if (siteSettingsData?.Courses.length === 1)
        // TBD handle null siteSettings
        return "Hole" + " " + order?.Hole.toString();
      else {
        let results = siteSettingsData?.Courses.filter((e) => {
          return e?.Number === order?.Course;
        });

        if (results.length > 0) {
          return results[0]?.Name + " " + order?.Hole.toString();
        } else {
          return (
            "Course" +
            " " +
            order?.Course.toString() +
            " " +
            "hole" +
            " " +
            order?.Hole.toString()
          );
        }
      }
    }
  }

  function createdTime(order) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let updated = moment
        .utc(order?.Created)
        .utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to local time zone at course
      return updated.format("hh:mm a");
    }
  }

  function fulfilled(order) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      if (order?.FulfilledDate) {
        let date = moment
          .utc(order?.FulfilledDate)
          .utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to local time zone at course

        return (
          date.format("hh:mm a") +
          " By " +
          order?.FulfilledBy
        );
      } else {
        return "";
      }
    }
  }

  function total(order) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let price = 0;
      for (let i = 0; i < order?.Items.length; i++) {
        price += order?.Items[i]?.ExtPrice;
      }

      return accounting
        .formatNumber(price, {
          precision: 2,
          thousand: siteSettingsData?.CurrencyThousandsSeparator,
          decimal: siteSettingsData?.CurrencyDecimalSeparator,
        })
        .toString();
    }
  }

  function price(item) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      return accounting
        .formatNumber(item?.Price, {
          precision: 2,
          thousand: siteSettingsData?.CurrencyThousandsSeparator,
          decimal: siteSettingsData?.CurrencyDecimalSeparator,
        })
        .toString();
    }
  }

  function extPrice(item) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      return accounting
        .formatNumber(item.ExtPrice, {
          precision: 2,
          thousand: siteSettingsData?.CurrencyThousandsSeparator,
          decimal: siteSettingsData?.CurrencyDecimalSeparator,
        })
        .toString();
    }
  }

  function fulfillOrder(order) {
    dispatch(COMMON_SERVICES.putFoodOrdersTabServices(order, siteId.get())).then(() => {
      let tempFoodOrdersStartDate = moment().local();
      tempFoodOrdersStartDate.hours(0).minutes(0).seconds(0).milliseconds(0); // midnight course time
      tempFoodOrdersStartDate.utcOffset(-siteSettingsData?.TimeZoneOffset);
      dispatch(
        COMMON_SERVICES.getFoodOrdersTabServices(
          tempFoodOrdersStartDate.toISOString(), siteId.get()
        )
      );
    });
  }

  function toggleDetail(orderIndex) {
    let tempFoodItems = [...displayFoodOrders];
    tempFoodItems[orderIndex].showDetail =
      !tempFoodItems[orderIndex].showDetail;
    setDisplayFoodOrders(tempFoodItems);
  }

  function handleRefresh() {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let tempFoodOrdersStartDate = moment().local();
      tempFoodOrdersStartDate.hours(0).minutes(0).seconds(0).milliseconds(0); // midnight course time
      tempFoodOrdersStartDate.utcOffset(-siteSettingsData?.TimeZoneOffset);

      dispatch(
        COMMON_SERVICES.getFoodOrdersTabServices(
          tempFoodOrdersStartDate.toISOString(), siteId.get()
        )
      );
    }
  }

  return (
    <Container>
      <Header>
        <div>
          <div>
            <Tooltip title={t("Show_completed_orders")}>
              <div className="header-checkbox-wrapper">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={fbOrdersSettings.get().showCompleted}
                      onChange={() => {
                        fbOrdersSettings.set({
                          ...fbOrdersSettings.get(),
                          showCompleted: !fbOrdersSettings.get().showCompleted,
                        });
                        localStorage.setItem(
                          "fbOrdersSettings",
                          JSON.stringify(fbOrdersSettings.get())
                        );
                      }}
                      icon={<UncheckIcon width={15} height={15} />}
                      checkedIcon={<CheckIcon width={15} height={15} />}
                    />
                  }
                  label={t("Show_completed_orders")}
                />
              </div>
            </Tooltip>
            <FormControl sx={{ minWidth: 70 }}>
              <Select
                IconComponent={KeyboardArrowDownIcon}
                value={fbOrdersSettings.get().refreshInterval}
                onChange={handleChange}
              >
                <MenuItem value={30}>30 s</MenuItem>
                <MenuItem value={60}>60 s</MenuItem>
                <MenuItem value={300}>5 m</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
            <Tooltip title={t("Refresh")}>
              <CircleBtn
                className="refresh-btn"
                onClick={handleRefresh}
                disabled={getFoodOrdersTabDataStatus == API_STATUSES.REQUEST}
              >
                <RefreshIcon color="#fff" />
                {t("Refresh")}
              </CircleBtn>
            </Tooltip>
          </div>

          <div className="btn-wrapper">
            {foodOrdersCourseFilter.get().courseFilters !== null &&
              foodOrdersCourseFilter.get() !== undefined &&
              foodOrdersCourseFilter.get().courseFilters.length !== 0 ? (
              <>
                {foodOrdersCourseFilter.get().courseFilters.map((course) => {
                  return (
                    <button
                      key={course?.number}
                      id={course?.number}
                      className={course?.active ? "active" : ""}
                      onClick={(e) => handleCourseToggle(e, course)}
                    >
                      {course?.name}
                    </button>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div>
          <Tooltip title={t("Full_screen")}>
            <CircleBtn
              className={
                sideDrawerState.get() ? "refresh-btn" : "refresh-btn-color"
              }
              onClick={() => sideDrawerState.set(!sideDrawerState.get())}
            >
              {t("Full_screen")}
            </CircleBtn>
          </Tooltip>
        </div>
      </Header>
      <BodyWrapper>
        {displayFoodOrders && displayFoodOrders.length !== 0 ? (
          displayFoodOrders?.map((order, index) => {
            if (showOrder(order)) {
              return (
                <Row>
                  <div className="row-header">
                    <p>{t("From")}</p>
                    <p>{t("Received")}</p>
                    <p>{t("Completed")}</p>
                    <p style={{ textAlign: "right" }}>{t("Order_total")}</p>
                    <p className="checkbox-wrapper">{t("Mark_completed")}</p>
                  </div>
                  <div className="row-body">
                    <div className="table-body-data">
                      <p>
                        {t("car")} {order?.CarNumber} {courseAndHole(order)}
                      </p>
                      <p>{createdTime(order)}</p>
                      <p>{fulfilled(order)}</p>
                      <p
                        className={
                          order?.FulfilledDate ? "un-active" : "active"
                        }
                        style={{ textAlign: "right" }}
                      >
                        {total(order)}
                      </p>
                      <div className="flex">
                        <Tooltip title="Mark Completed">
                          <button
                            className={
                              order?.FulfilledDate
                                ? "un-active check-btn"
                                : "active check-btn"
                            }
                            onClick={() => {
                              if (!order?.FulfilledDate) {
                                fulfillOrder(order);
                              } else {
                                return;
                              }
                            }}
                          >
                            <CheckIcon width={48} height={48} />
                            <p>{t("Mark_completed")}</p>
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                    <AccordionWrapper>
                      <Accordion
                        expanded={order?.showDetail}
                        onChange={() => toggleDetail(index)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Tooltip
                            title={
                              order?.showDetail
                                ? "Hide Details"
                                : "Show Details"
                            }
                          >
                            <Typography>
                              {order?.showDetail
                                ? "Hide Details"
                                : "Show Details"}
                            </Typography>
                          </Tooltip>
                        </AccordionSummary>
                        <AccordionDetails className="table-accordion-detail">
                          <TableWrapper>
                            <table>
                              <thead>
                                <tr>
                                  <th>
                                    <span>{t("Qty")}</span>
                                  </th>
                                  <th>
                                    <span>{t("Item")}</span>
                                  </th>
                                  <th>
                                    <span>{t("Each")}</span>
                                  </th>
                                  <th>
                                    <span>{t("Total")}</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {order?.Items?.map((item) => {
                                  return (
                                    <tr>
                                      <td>
                                        <span>
                                          {!item?.IsOption
                                            ? item?.Quantity
                                            : ""}
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {item?.IsOption ? "+ " : ""}
                                          <span
                                            className={
                                              item?.IsOption ? "small" : ""
                                            }
                                          >
                                            {item?.Description}
                                          </span>
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {price(item) !== "0.00" &&
                                            price(item)}
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {extPrice(item) !== "0.00" &&
                                            extPrice(item)}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </TableWrapper>
                        </AccordionDetails>
                      </Accordion>
                    </AccordionWrapper>
                  </div>
                </Row>
              );
            }
          })
        ) : (
          <>
            <div className="no-data">{t("No_data")}</div>
          </>
        )}
      </BodyWrapper>
    </Container>
  );
};
